export type ExplorerViewMode = 'grid' | 'list' | 'table';

export type ExplorerPreferences = {
  version: 1;
  defaultView: ExplorerViewMode;
  departmentColorsEnabled: boolean;
};

export const EXPLORER_PREFERENCES_STORAGE_KEY = 'scarlet-explorer-preferences';
export const LEGACY_EXPLORER_VIEW_STORAGE_KEY = 'scarlet-explorer-view';

export const DEFAULT_EXPLORER_PREFERENCES: ExplorerPreferences = {
  version: 1,
  defaultView: 'list',
  departmentColorsEnabled: true,
};

export function isExplorerViewMode(value: unknown): value is ExplorerViewMode {
  return value === 'grid' || value === 'list' || value === 'table';
}

export function parseExplorerPreferences(value: unknown): ExplorerPreferences | null {
  if (!value || typeof value !== 'object') return null;
  const candidate = value as Partial<ExplorerPreferences>;
  if (
    candidate.version !== 1 ||
    !isExplorerViewMode(candidate.defaultView) ||
    typeof candidate.departmentColorsEnabled !== 'boolean'
  ) {
    return null;
  }

  return {
    version: 1,
    defaultView: candidate.defaultView,
    departmentColorsEnabled: candidate.departmentColorsEnabled,
  };
}
